import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';

type SessionInvalidationPayload = {
  id_token: string;
};

@Injectable({
  providedIn: 'root'
})
export class SessionInvalidationService {
  constructor(
    private http: HttpClient,
    @Inject('API_URL') private apiUrl: string
  ) {}

  invalidateSession(): Observable<boolean> {
    const payload = this.buildPayload();
    const headers = this.buildHeaders();

    return this.http.post<void>(`${this.apiUrl}/user/session/invalidate`, payload, { headers }).pipe(
      timeout(5000),
      map(() => true),
      catchError((error) => {
        console.error('Failed to invalidate user session:', error);
        return of(false);
      })
    );
  }

  private buildPayload(): SessionInvalidationPayload {
    const idToken = sessionStorage.getItem('id_token') || '';

    return {
      id_token: idToken
    };
  }

  private buildHeaders(): HttpHeaders {
    const token = sessionStorage.getItem('token') || '';
    const idToken = sessionStorage.getItem('id_token') || '';

    let headers = new HttpHeaders();

    if (token) {
      headers = headers.set('Authorization', token);
    }

    if (idToken) {
      headers = headers.set('id_token', idToken);
    }

    return headers;
  }
}
